import { Box, SxProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialogHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
}));

export const modeTemplatesMain: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
  width: '100%',
  height: '100%',
  overflowY: 'auto',
};

export const modeTemplatesWrapper: SxProps<Theme> = {
  flex: 1,
};
